module.exports = __webpack_public_path__ + "img/mediumLogo.be9ab174.png";